import { useQuery } from 'react-query';
import { QueryKeys } from '@frontend/features/common/types';
import {FlightIntegrationDto, FlightIntegrationListDto, PagedFilter, PagedResponse} from '@bandido/shared/dist/dtos';
import { AxiosError, AxiosResponse } from 'axios';
import { client } from '@frontend/features/common/services';

export interface useGetAllFlightIntegrationsProps extends PagedFilter {
  onErrorCallback?: (_e: AxiosError) => void;
  search?: string;
}

export const useGetAllFlightIntegrations = ({
  currentPage,
  onErrorCallback,
  pageSize,
  search,
}: useGetAllFlightIntegrationsProps) =>
  useQuery({
    queryKey: [QueryKeys.getAllFlightIntegrations, currentPage, pageSize, search],
    queryFn: async (): Promise<PagedResponse<FlightIntegrationListDto> | undefined> => {
      try {
        const flightIntegrations: AxiosResponse<PagedResponse<FlightIntegrationListDto>, any> = await client.get(
          'flight-integrations',
          {
            params: {
              currentPage,
              pageSize,
              search,
            },
          },
        );

        return flightIntegrations.data;
      } catch (e) {
        onErrorCallback && onErrorCallback(e as AxiosError);
      }
    },
    refetchOnWindowFocus: true,
  });

export const useGetFlightIntegrationById = (id: string) => {
  return useQuery([QueryKeys.getAFlightIntegrationById, id], async ():Promise<FlightIntegrationDto> => {
    const { data } = await client.get(`/flight-integrations/${id}`);
    return data;
  });
};
